module.exports = __webpack_public_path__ + "static/img/smart-splitter_256.6662e4d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/smart-splitter_256.png
// module id = 9X6k
// module chunks = 0